<template>
  <div :class="$style.wxShareGuide" v-if="visible">
    <div :class="$style.wxShareGuideBackdrop" @click="close"></div>
    <img :class="$style.wxShareGuideImg" src="./img/share-arrow.png" />
    <div :class="$style.wxShareGuideContent">
      <div :class="$style.text1"
        >还差<span :class="$style.redText">{{ remainPeople }}</span
        >个人成团，快去邀请好友吧！</div
      >
      <CountDown :time="remainTime" :class="$style.text2">
        <template v-slot:default="time">
          剩余<span :class="$style.time"
            >{{ time.hour }}:{{ time.minute }}:{{ time.second }}</span
          >结束
        </template>
      </CountDown>
    </div>
  </div>
</template>

<script>
import CountDown from "components/CountDown";

export default {
  name: "WxShareGuide",
  props: {
    remainTime: {},
    remainPeople: {},
    visible: {
      type: Boolean,
    },
  },
  components: {
    CountDown,
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.wxShareGuide {
  position: relative;
  z-index: $zindex-popover;
}

.wxShareGuideBackdrop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
}

.wxShareGuideImg {
  position: fixed;
  top: 21px;
  right: 49px;
  width: 68px;
  height: 67px;
}

.wxShareGuideContent {
  position: fixed;
  top: 118px;
  right: 50px;
  text-align: center;
  line-height: 1;
}

.text1 {
  font-size: rem(18px);
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}

.text2 {
  margin-top: 8px;
  font-size: rem(15px);
  color: rgba(255, 255, 255, 1);
}

.time {
  display: inline-block;
  text-align: left;
  width: rem(65px);
  padding-left: rem(2px);
  color: #E95A59;
}
</style>
